import { useMemo } from "react";
import { useGetPropertyOutstandingDues } from "@/services";
import { formatAmount } from "@/lib/utils";

const useOccupantsDialog = ({ selectedRow }: {selectedRow: any}) => {
  const propertyIds = useMemo(
    () =>
      (selectedRow?.properties || [])
        .map((property: any) => property?.propertyId)
        .filter((id: any) => id != null && id !== ""),
    [selectedRow]
  );

  const {
    data: outstandingDues,
    isLoading: isDocLoading,
  } = useGetPropertyOutstandingDues({
    userId: selectedRow?.userId,
    propertyIds,
    queryParams: {
      enabled: !!selectedRow?.userId,
    },
  });

  const documentList = useMemo(
    () =>
      (outstandingDues?.data?.properties || []).flatMap((property: any) =>
        (property?.items || []).map((item: any) => ({
          ...item,
          propertyId: property?.propertyId,
          displayId: property?.displayId,
          propertyName: property?.propertyName,
          unitNumber: property?.unitNumber,
        }))
      ),
    [outstandingDues]
  );

  const columns = [
    {
      accessorKey: "displayId",
      header: <div>Property</div>,
      accessorFn: (row: any) =>
        `${row?.displayId || row?.propertyName || ""}${row?.unitNumber ? ` (${row.unitNumber})` : ""}`.trim(),
    },
    {
      accessorKey: "ownerName",
      header: <div>Owner Account</div>,
      accessorFn: (row: any) => String(row?.ownerName || ""),
    },
    {
      accessorKey: "glMasterName",
      header: <div>Charge</div>,
      accessorFn: (row: any) => String(row?.charge || row?.glMasterName || ""),
    },
    {
      accessorKey: "balance",
      header: <div>Balance</div>,
      accessorFn: (row: any) => formatAmount(row?.balance || "0"),
    },
  ]

  return {
    columns,
    documentList,
    isDocLoading,
  }
}

export default useOccupantsDialog;
